import { c as _c } from "react/compiler-runtime";
import RatingBadge from '@/components/modules/rating/RatingBadge';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import RatingsBannerEntityInfo from './RatingsBannerEntityInfo';
import RatingsBannerImage from './RatingsBannerImage';
import RatingsDetail from './RatingsDetail';
const RatingsBanner = t0 => {
    const $ = _c(27);
    const { entity, reducedSectionWidth } = t0;
    const translate = useTranslate();
    const mainImage = entity.medias.media && entity.medias.media.length ? entity.medias.media[0] : null;
    const ratingByType = entity.rating?.byType ?? null;
    let t1;
    if ($[0] !== translate) {
        t1 = translate("review.only_booked_reviews");
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const onlyBookedReviewsText = t1;
    const contentClassName = `flex flex-col flex-grow w-full ${reducedSectionWidth ? "mdlg:justify-center" : "mdlg:flex-row mdlg:justify-between mdlg:items-center mdlg:flex-wrap mdlg:content-center"}`;
    const entityInfoClassName = `flex flex-col items-center flex-shrink mdlg:items-start mdlg:mt-2 ${reducedSectionWidth ? "" : "mdlg:justify-center mdlg:mr-4"}`;
    const onlyBookedReviewsClassName = `justify-self-end text-xs text-gray-400 mdlg:self-start ${reducedSectionWidth ? "" : "lg:self-end"}`;
    const detailClassName = `flex flex-col justify-center items-center flex-shrink-0 my-4 mdlg:w-max ${reducedSectionWidth ? "mdlg:items-start" : ""}`;
    let t2;
    if ($[2] !== mainImage) {
        t2 = <RatingsBannerImage media={mainImage} className="w-full flex-shrink-0 h-44 sm:h-56 mdlg:rounded-l mdlg:h-auto mdlg:self-stretch mdlg:w-68 mdlg:min-h-44 mdlg:mx-0 lg:w-72"/>;
        $[2] = mainImage;
        $[3] = t2;
    }
    else {
        t2 = $[3];
    }
    const t3 = entity.rating?.average;
    const t4 = entity.rating?.count;
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
        t5 = <RatingBadge rating={t3} count={t4} className="transform -translate-y-1/2 mdlg:translate-y-0 mdlg:-translate-x-1/2"/>;
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    }
    else {
        t5 = $[6];
    }
    let t6;
    if ($[7] !== entity || $[8] !== entityInfoClassName) {
        t6 = <RatingsBannerEntityInfo entity={entity} className={entityInfoClassName}/>;
        $[7] = entity;
        $[8] = entityInfoClassName;
        $[9] = t6;
    }
    else {
        t6 = $[9];
    }
    let t7;
    if ($[10] !== detailClassName || $[11] !== ratingByType) {
        t7 = <RatingsDetail byType={ratingByType} className={detailClassName}/>;
        $[10] = detailClassName;
        $[11] = ratingByType;
        $[12] = t7;
    }
    else {
        t7 = $[12];
    }
    let t8;
    if ($[13] !== contentClassName || $[14] !== t6 || $[15] !== t7) {
        t8 = <div className={contentClassName}>{t6}{t7}</div>;
        $[13] = contentClassName;
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
    }
    else {
        t8 = $[16];
    }
    let t9;
    if ($[17] !== onlyBookedReviewsClassName || $[18] !== onlyBookedReviewsText) {
        t9 = <p className={onlyBookedReviewsClassName}>{onlyBookedReviewsText}</p>;
        $[17] = onlyBookedReviewsClassName;
        $[18] = onlyBookedReviewsText;
        $[19] = t9;
    }
    else {
        t9 = $[19];
    }
    let t10;
    if ($[20] !== t8 || $[21] !== t9) {
        t10 = <div className="flex flex-col flex-grow justify-center items-center -mt-12 mx-4 md:self-stretch mdlg:mx-0 mdlg:py-4 mdlg:mt-0 mdlg:-ml-6">{t8}{t9}</div>;
        $[20] = t8;
        $[21] = t9;
        $[22] = t10;
    }
    else {
        t10 = $[22];
    }
    let t11;
    if ($[23] !== t10 || $[24] !== t2 || $[25] !== t5) {
        t11 = <div className="rounded relative flex flex-col items-center bg-white border border-gray-100 pb-4 mdlg:min-h-68 mdlg:pb-0 mdlg:w-full mdlg:mx-0 mdlg:flex-row mdlg:pr-8 lg:pr-14">{t2}{t5}{t10}</div>;
        $[23] = t10;
        $[24] = t2;
        $[25] = t5;
        $[26] = t11;
    }
    else {
        t11 = $[26];
    }
    return t11;
};
export default RatingsBanner;
